import { useState, useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
  List,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";

export default function UpdateStockForm({
  open,
  onClose,
  onSubmit,
  onReset,
  stocks,
  quantities,
  handleQuantityChange,
  message,
}) {
  const [selectedType, setSelectedType] = useState("");

  // Obtener tipos de producto unicos
  const productTypes = useMemo(() => {
    const types = Array.from(new Set(stocks.map((s) => s.product_type).filter(Boolean)));
    return types;
  }, [stocks]);

  // Setear tipo por defecto si hay
  if (!selectedType && productTypes.length > 0) {
    setSelectedType(productTypes[0]);
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Registrar Entrada de Stock</DialogTitle>
      <DialogContent
        sx={{
          height: "70vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexGrow: 1 }}>
          {/* Barra lateral con tipos */}
          <Box
            sx={{
              width: "25%",
              borderRight: "1px solid #ccc",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
              maxHeight: "60vh",
            }}
          >
            <List>
              {productTypes.map((type) => (
                <ListItemButton
                  key={type}
                  selected={selectedType === type}
                  onClick={() => setSelectedType(type)}
                >
                  <ListItemText primary={type} />
                </ListItemButton>
              ))}
            </List>
          </Box>

          {/* Productos filtrados */}
          <Box
            sx={{
              width: "75%",
              padding: 1,
              overflowY: "auto",
              maxHeight: "60vh",
            }}
          >
            {stocks
              .filter((s) => s.product_type === selectedType)
              .map((stock) => {
                const currentQty = quantities[stock.id] || 0;
                return (
                  <Box
                    key={stock.id}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        maxWidth: 450,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      {stock.product_name}{" "}
                      <span style={{ color: "blue" }}>
                        (Stock actual: {stock.quantity}
                        {currentQty > 0 && (
                          <span style={{ color: "green" }}> → {stock.quantity + currentQty}</span>
                        )}
                        )
                      </span>
                    </Typography>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ minWidth: 30 }}
                        onClick={() =>
                          handleQuantityChange(stock.id, Math.max(currentQty - 1, 0))
                        }
                      >
                        −
                      </Button>

                      <TextField
                        type="number"
                        size="small"
                        sx={{ 
                          width: 60,
                          '& input[type=number]::-webkit-outer-spin-button': {
                            WebkitAppearance: 'none',
                            margin: 0,
                          },
                          '& input[type=number]::-webkit-inner-spin-button': {
                            WebkitAppearance: 'none',
                            margin: 0,
                          },
                          '& input[type=number]': {
                            MozAppearance: 'textfield',
                          },
                        }}
                        value={currentQty || ""}
                        onChange={(e) =>
                          handleQuantityChange(stock.id, Number(e.target.value))
                        }
                      />

                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ minWidth: 30 }}
                        onClick={() =>
                          handleQuantityChange(stock.id, currentQty + 1)
                        }
                      >
                        +
                      </Button>
                    </Box>
                  </Box>
                );
              })}
          </Box>
        </Box>

        <Divider sx={{ my: 1 }} />

        {message && (
          <Typography color="error" sx={{ mb: 1 }}>
            {message}
          </Typography>
        )}

        <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
          <Button onClick={onReset} color="secondary">
            Restablecer
          </Button>
          <Box>
            <Button onClick={onClose} color="primary">
              Cerrar
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              sx={{ ml: 1 }}
              onClick={onSubmit}
            >
              Confirmar
            </Button>
          </Box>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}